













import { Component, Vue, Prop } from 'vue-property-decorator'
import VueUploadComponent from 'vue-upload-component'

@Component({
    components: {
        VueUploadComponent
    }
})
export default class VueUpload extends Vue {

    @Prop(String) inputId!: string

    files: Array <object> = []

    catchFiles(files: any) {
        if (files.length) {

            const vueupload: any = this.$refs.vueupload as Vue

            this.$emit('uploaded-files', files)
            vueupload.clear()
        }
    }

}
